import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { trackPageView } from '../util/Analytics.jsx';
import { useStateValue } from '../context/state.jsx';
import Utils from '../util/Utils.jsx';

const LayoutPage = () => {
	const [haveLayout, setHaveLayout] = useState(false);
	const [fetchedDatasetId, setFetchedDatasetId] = useState(null);
	const [, dispatch] = useStateValue();
	const { layoutId } = useParams();

	useEffect(() => {
		trackPageView();
		Utils.ajax(
			'applyExternalLayout',
			{ layoutId },
			dispatch,
			result => {
				setFetchedDatasetId(result.dataset);
				setHaveLayout(true);
			}
		);
	}, []);

	return haveLayout ? (<Navigate to={`/app/dataset/${fetchedDatasetId}`} replace />) : (<div></div>);
};

export default LayoutPage;